"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.financialsStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
const store_1 = require("client/modules/users/store");
class FinancialsStore {
    constructor() {
        this.showLoader = false;
        /** Query Actions */
        this.getPeriodData = async (endDate, siteId = store_1.usersStore.user.value.siteId, startDate) => {
            const result = await api_1.FinancialsEndpoint.getPeriodData.apiCall(null, {
                endDate,
                siteId,
                startDate
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                console.log("error in loading financial Period Data:", result.code);
                alert(`Error in loading period data: ${result.code}`);
                return null;
            }
            this.showLoader = false;
            return result.data;
        };
        /** End Query Actions */
    }
}
__decorate([
    mobx_1.observable
], FinancialsStore.prototype, "showLoader", void 0);
exports.financialsStore = new FinancialsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/financial/store.ts
// module id = 3452
// module chunks = 0